import React, { Fragment, useState } from 'react';
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CargosService from '../../../../services/cargos';
import '../../../../styles/botao.scss'



const FormCadCargo = () => {
    const [cargo, setCargo] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const carg = await CargosService.cadastro({
                cargo: cargo
            })
            if (carg.data["_id"]) {
                setSucesso(true);
            }
            else {
                alert(carg.data["error"]);
            }
        } catch (error) {
            setError("Deu algo errado no seu cadastro!")
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setCargo("");
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={1} lg={2}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={1} lg={3}>
                                <Col xs={12} lg={6}>
                                    <Form.Group className="mb-3" controlId="cargo">
                                        <Form.Label>Cargo</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            name="cargo"
                                            value={cargo}
                                            onChange={e => setCargo(e.target.value)} />
                                    </Form.Group>
                                </Col>

                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={3}>
                                    <Button variant="success" className="alinha-botao" type="submit">
                                        Cadastrar
                                    </Button>
                                </Col>
                            </Row>
                        </Form >
                    </Row>
                    <br />
                    <Link to={'/rh/cargos'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>Cargo cadastrado com sucesso!</Alert>
                    <Button onClick={addNovo} variant="success" type="submit">
                        Adicionar outro
                    </Button>
                    <br /><br />
                    <Link to={'/rh/cargos/listar'}>
                        <Button variant="primary" type="button">
                            Ir para Listagem de Cargos
                        </Button>
                    </Link>
                    <br /><br />
                    <Link to={'/rh/cargos'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Container>
            </Fragment>
        )
    }
}

export default FormCadCargo;